import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { loadUser, loadUserSuccess, loadUserFailure } from './user-details.action';
import { CustomerService } from '../../../shareModule/services/customer.service';
import { ApiResponse } from '../../models/common.model';
import { Store } from '@ngrx/store';
import { selectUser } from './user-details.selector';
import { MemberNotificationService } from '../../services/member-notification.service';
import { AppState } from '../app.state';

@Injectable()
export class userEffects {
  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private customerService: CustomerService,
    private store: Store<AppState>,
    private notificationService: MemberNotificationService,

  ) {

  }

  loadUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUser),
      withLatestFrom(this.store.select(selectUser)),
      switchMap(([action, previousState]) => {
        return this.customerService.getProfileInfo(action.id)
          .pipe(
            map((response: ApiResponse) => {
              console.log(response.body, "RESPONSE BODY")
              this.levelUpNotification(previousState?.level, response.body.level);
              // response.body.level = 10
              return loadUserSuccess({ user: response.body });
            }),
            catchError((error) => of(loadUserFailure({ error })))
          );
      })
    )
  );


  private levelUpNotification(previousUserLevel, currentUserLevel) {
    // ********  user leveled up notification ----->
    if (previousUserLevel && currentUserLevel > previousUserLevel) {
      this.notificationService.notifyUser("Level Up", `🎉 Congratulations! You've leveled up to Level ${currentUserLevel}! 🎉`);
    }// ********  user leveled up notification ----->
  }

}